import { useCallback } from 'react';

import * as pas from '../../../pas';
import { useLogout } from '../../useLogout';
import { useValidatePin } from './useValidatePin';
import { useValidateFitToPlay } from './useValidateFitToPlay';
import { useValidateTCVersion } from './useValidateTCVersion';
import { useValidatePasswordChange } from './useValidatePasswordChange';
import { useContinueLoginWithSessionToken } from '../../useContinueLoginWithSessionToken';

export const useReLogin = (validationsRef) => {
    const logout = useLogout();
    const continueLoginWithSessionToken = useContinueLoginWithSessionToken();
    const validateTCVersion = useValidateTCVersion(validationsRef);
    const validatePasswordChange = useValidatePasswordChange(validationsRef);
    const validatePin = useValidatePin(validationsRef);
    const validateFitToPlay = useValidateFitToPlay(validationsRef);

    return useCallback(async ({ credentials, options, validate2FA }) => {
        const pasLoginResponse = await pas.login(credentials);
        const { sessionToken: { sessionToken } = {} } = pasLoginResponse?.data || {};

        validateTCVersion(pasLoginResponse, credentials, options);
        validatePasswordChange(pasLoginResponse, credentials, options);
        validatePin(pasLoginResponse, credentials, options);
        validateFitToPlay(pasLoginResponse, credentials, options);
        validate2FA(pasLoginResponse, credentials, options);

        if (validationsRef.current.size === 0) {
            try {
                const { afterRegisterLogin, isAfterLoginWithCredentials } = options || {};

                await continueLoginWithSessionToken({
                    ...credentials,
                    sessionToken,
                    afterRegisterLogin,
                    isAfterLoginWithCredentials
                });
            } catch {
                await logout();
            }
        }
    }, [
        validationsRef, logout, continueLoginWithSessionToken,
        validateTCVersion, validatePasswordChange, validatePin, validateFitToPlay
    ]);
};
